import { Mutation } from 'vuex'
import { MedicalDocumentState } from './state'

export default {
  /** @type {Mutation<MedicalDocumentState>} */
  upsertData(state, data) {
    state.data = data
  },

  /** @type {Mutation<MedicalDocumentState>} */
  upsertCurrentStep(state, currentStep) {
    state.currentStep = currentStep
  },

  /** @type {Mutation<MedicalDocumentState>} */
  clean(state) {
    state.data = {}
    state.currentStep = null
  },
}
